function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 97.9L0 172l13.2 25 14.7-7.7v94.1h227.7v-94.1l14.7 7.7 13.2-25-141.8-74.1zm85.5 157.4H56.4v-80.7l85.3-44.6 85.3 44.6v80.7h.2zM78 42.5H44.5L56.7 0 0 70.9h33.4l-12.1 42.5L78 42.5z"
})));